export default __webpack_public_path__ + "static/media/youtube_small.2c7b0381.svg";